import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface CreatePulverizationActivityPayload {
  start_date: string
  end_date: string
  description: string
  mapping_id: string
}

export async function createPulverizationActivity(
  payload: CreatePulverizationActivityPayload,
): Promise<void> {
  await companiesApi.post(apiRoutes.createPulverizationActivity, payload)
}
